module.exports = __webpack_public_path__ + "img/163.4efc0dc6.svg";